import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;

const FormNewPassword = ({onConfirm, error}) => {
  const [email, setEmail] = useState('');


  return (

    <Card>
      <Typo variant="h1">Forgot password</Typo><br/>
      <>Recover your account.</>

      <Row>
        <Col widthmd="12">
          <Input
            label={"Email"}
            name="email"
            type="email"
            width="100%"
            value={email}
            onChange={(val) => setEmail(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "forgot-password",
            params: {
              email: email
            }
          })}>Recover</Button>
        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
      </Row>
    </Card>
  )
}

export default FormNewPassword;
